import { makeStyles, tokens } from '@fluentui/react-components'

const fadeTransition = {
  transitionDuration: tokens.durationFaster,
  transitionTimingFunction: tokens.curveEasyEase,
} as const

const useStyles = makeStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    // 10px between title section and status card / footer — no standard token
    gap: '10px',
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalM,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderRadius: tokens.borderRadiusXLarge,
    boxShadow: tokens.shadow4,
    backgroundColor: tokens.colorNeutralBackground1,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ':active': {
      backgroundColor: tokens.colorNeutralBackground1Pressed,
    },
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    gap: tokens.spacingHorizontalXS,
  },
  title: {
    flex: '1 0 0',
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  iconGroup: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: tokens.spacingHorizontalXXS,
    width: 0,
    overflow: 'hidden',
  },
  iconGroupVisible: {
    width: 'fit-content',
    overflow: 'visible',
  },
  // Controls layout space: collapses the more-actions button out of flow so the title
  // can grow to fill the full width. Expands on hover/focus to reserve room for the button.
  actionSlot: {
    width: 0,
    overflow: 'hidden',
    flexShrink: 0,
    transitionProperty: 'width',
    ...fadeTransition,
  },
  actionSlotVisible: {
    width: tokens.spacingHorizontalXXXL,
  },
  star: {
    color: tokens.colorPaletteMarigoldBackground3,
  },
  // Controls visual appearance: fades a button in/out without affecting layout.
  // Used on the more-actions button (alongside actionSlot) to fade as the slot opens,
  // and standalone on the star button (whose layout is managed by iconGroup instead).
  buttonHidden: {
    opacity: 0,
    transitionProperty: 'opacity',
    ...fadeTransition,
  },
  buttonVisible: {
    opacity: 1,
  },
  grayParagraph: {
    color: tokens.colorNeutralForeground3,
    margin: 0,
  },
  promptClamped: {
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
  },
})

export { useStyles }
